import { Col, Container, Row } from 'react-bootstrap';

const Hero = () => {
    return (
        <section className="hero-4 pb-2 pt-2 py-sm-2 bg-gradient2">
            <Container>
                <Row className="justify-content-center">
                    <Col lg={7} className="text-center">
                        <h1 className="hero-title">404 Not Found</h1>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default Hero;
